import { ApplicationState } from 'application/redux';
import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { clearFields } from 'modules/operational/device/detail/_settings/redux/actions';
import { connect } from 'react-redux';
import { clear } from '../../../modules/operational/device/detail/settings/redux/actions';
import { toggleUserSettings } from '../../../modules/user/profile/redux/actions';
import NavbarComponent from './navbar-component';
import { changeMenu, getSubMenus } from './redux/actions';

const mapStateToProps = (state: ApplicationState) => ({
  settings: state.devices.detail.settings,
  actions: state.devices.detail.settings.actions,
  navbar: state.navbar.navbar,
  t: state.i18n.t,
  userSettings: state.navbar.userSettings,
  _settings: state.devices.detail._settings
});

export default connect(mapStateToProps, {
  changeMenu,
  getSubMenus,
  openModal,
  toggleUserSettings,
  closeModal,
  clear,
  clearFields
})(NavbarComponent);
